import React from 'react';
import { MdArrowBack } from 'react-icons/md';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MediaQuery from 'react-responsive';
import authActions from '../../../store/actions/auth';
import { serverLogout } from '../../../data/user/actions';
import Auth0 from '../../../store/actions/auth/Auth';
import AccountDropdown from './components/AccountDropdown/';
import Navigation from './components/Navigation/';
import SideMenu from './components/SideMenu';
import ModeSwitch from './components/ModeSwitch';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../../LanguageSelector';

const PageHeader = ({ title, backLink, userCanUploadFiles, navItems: propsNavItems }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation('pageHeader');
  
  const authenticated = useSelector((state) => state.auth.authenticated);
  const clientInfo = useSelector((state) => state.user.clientInfo);

  const handleSignin = () => dispatch(authActions.signinUser());
  const handleSignout = async () => {
    await serverLogout();
    dispatch(authActions.signoutUser());
  };
  const handleSignup = () => dispatch(authActions.signupUser());
  const handleGoBack = () => navigate(-1);

  let navItems = propsNavItems;
  if (navItems !== undefined && !userCanUploadFiles) {
    navItems = navItems.filter(({ link }) => link !== '/upload');
  }

  return (
    <header className="page-header">
      <MediaQuery maxWidth={768}>
        {navItems && <SideMenu navItems={navItems} />}
      </MediaQuery>
      {backLink && (
        <button onClick={handleGoBack} className="back-button">
          <MdArrowBack />
        </button>
      )}
      <MediaQuery minWidth={769}>
        <span className="page-header__title">{title}</span>
        {navItems && <Navigation navItems={navItems} />}
      </MediaQuery>
      <div className="page-header__actions">
        {!authenticated ? (
          <>
            <LanguageSelector />
            <button onClick={handleSignin} className="btn btn--transparent btn--white">
              {t('login')}
            </button>
            <button onClick={handleSignup} className="btn btn--primary">
              {t('createAccount')}
            </button>
          </>
        ) : (
          <>
            <ModeSwitch Auth0={Auth0} />
            <LanguageSelector />
            <AccountDropdown signoutUser={handleSignout} clientInfo={clientInfo} />
          </>
        )}
      </div>
    </header>
  );
};

export default PageHeader;
